import { /*React,*/ useState } from 'react';
// import { Link } from 'react-router-dom';

import faqImg from '../assets/images/phone/2.png';

// import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/scss/modal-video.scss';

import CountUp from 'react-countup';

import { FiChevronUp, FiDownload } from 'react-icons/fi';

import { faq } from '../data/data';
import { useTranslation } from 'react-i18next';

interface FaqData {
  id: number;
  title: string;
  desc: string;
}

export default function Faq() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<number>(1);

  return (
    <div className="container relative">
      <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[30px]">
        {/* Görsel Alanı */}
        <div className="relative order-1 md:order-2">
          <div className="relative">
            <img src={faqImg} className="mx-auto md:max-w-xs lg:max-w-sm" alt="" />
          </div>
          <div className="overflow-hidden absolute md:size-[500px] size-[400px] bg-gradient-to-tr to-indigo-500/20 via-indigo-500/70 from-indigo-500 bottom-1/2 translate-y-1/2 md:end-0 end-1/2 md:translate-x-0 translate-x-1/2 -z-1 shadow-md shadow-indigo-500/10 rounded-full"></div>

          <div className="absolute bottom-28 md:start-0 -start-5 p-4 rounded-lg shadow-md dark:shadow-gray-800 bg-white dark:bg-slate-900 w-75 m-3">
            <div className="flex items-center">
              <div className="flex items-center justify-center size-[65px] bg-indigo-500/5 text-indigo-500 text-center rounded-full me-3">
                <FiDownload className="size-6" />
              </div>
              <div className="flex-1">
                <h6 className="text-slate-400">{t('faq.counterTitle')}</h6>
                <p className="text-xl font-bold">
                  <CountUp className="counter-value" end={500} />+
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* SSS İçeriği */}
        <div className="lg:me-8 order-2 md:order-1">
          <h6 className="text-indigo-500 uppercase text-sm font-bold tracking-wider mb-3">
            {t('faq.subtitle')}
          </h6>
          <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
            {t('faq.title')}
          </h4>
          <p className="text-slate-400 max-w-xl mx-auto">{t('faq.description')}</p>

          <div id="accordion-collapseone" className="mt-8">
            {faq.map((item: FaqData, index: number) => (
              <div
                key={index}
                className={`relative shadow dark:shadow-gray-800 rounded-md overflow-hidden ${
                  item.id !== 1 ? 'mt-3' : ''
                }`}
              >
                <h2 className="font-semibold">
                  <button
                    type="button"
                    onClick={() => setActiveTab(item.id)}
                    className={`flex justify-between items-center p-5 w-full font-medium text-start ${
                      activeTab === item.id
                        ? 'bg-slate-50/50 dark:bg-slate-800/20 text-indigo-500'
                        : ''
                    }`}
                  >
                    <span>{t(item.title)}</span>
                    <FiChevronUp
                      className={`size-4 shrink-0 ${activeTab === item.id ? '' : 'rotate-180'}`}
                    />
                  </button>
                </h2>
                <div className={`${activeTab === item.id ? '' : 'hidden'}`}>
                  <div className="p-5">
                    <p className="text-slate-400 dark:text-gray-400">{t(item.desc)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
